import { Star } from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Skeleton,
    Typography,
    useMediaQuery,
} from '@mui/material';
import React from 'react';

const ExperienceCardLoadingSkeleton = ({
    isSmallChat,
}: {
    isSmallChat?: boolean;
}) => {
    return (
        <Box
            sx={{
                textDecoration: 'none',
                height: '100%',
            }}
        >
            <Card
                variant='outlined'
                sx={{
                    position: 'relative',
                    maxWidth: 500,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'white.main',
                    borderRadius: '8px',
                    boxShadow: 0,
                    overflow: 'hidden',
                    height: '100%',
                }}
            >
                <CardActionArea
                    disableRipple
                    disableTouchRipple
                    focusRipple={false}
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        cursor: 'default',
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            aspectRatio: '1 / 1',
                        }}
                    >
                        <Skeleton
                            variant='rectangular'
                            animation='wave'
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                width: '100%',
                                height: '100%',
                                borderRadius: 0,
                            }}
                        />
                    </Box>

                    <CardContent
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            padding: isSmallChat ? 1.2 : 2,
                            width: '100%',
                            gap: 1,
                            minHeight: 120,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0,
                            }}
                        >
                            <Skeleton
                                variant='text'
                                animation='wave'
                                width='70%'
                                height={28}
                            />

                            <Skeleton
                                variant='text'
                                animation='wave'
                                width='45%'
                                height={24}
                            />

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                }}
                            >
                                <AccessTimeIcon
                                    sx={{
                                        fontSize: '16px',
                                        color: 'action.disabled',
                                    }}
                                />
                                <Skeleton
                                    variant='text'
                                    animation='wave'
                                    width={120}
                                    height={20}
                                />
                            </Box>

                            <Typography
                                variant='body3'
                                sx={{
                                    fontWeight: '700',
                                    fontSize: '.65rem',
                                }}
                            >
                                <Skeleton
                                    variant='text'
                                    animation='wave'
                                    width={110}
                                    height={20}
                                />
                            </Typography>
                        </Box>
                    </CardContent>
                </CardActionArea>
            </Card>
        </Box>
    );
};

export default ExperienceCardLoadingSkeleton;
